<div class="dprd-error-panel">
    <div class="error-container">
        <div class="avatar">
            <img id="avatarContent" [alt]="imageAlt | translate"
                [src]="imagePath | translate" />
        </div>
        <div class="message-container">
            <h2 class="title">
                <div id="titleContent">{{ title | translate }}</div>
            </h2>
            <div class="message">
                <p id="messageContent">
                    {{ message | translate }}
                </p>
            </div>
        </div>
    </div>
</div>